import { useEffect, useRef } from 'react';

import { Step } from 'src/components/VacancyCreate/contexts/StepsContext/types';
import { useSelector } from 'src/hooks/useSelector';

const useScroll = ({
    steps,
    currentStepIndex,
    scrollToStep,
}: {
    steps: Step[];
    currentStepIndex: number;
    scrollToStep: (stepIndex: number) => void;
}) => {
    // Скролл к конректному шагу по квери параметру
    const queryStepIndexToScroll = useSelector((state) => state.router.location.query.step);

    useEffect(() => {
        if (!isNaN(+queryStepIndexToScroll)) {
            scrollToStep(+queryStepIndexToScroll);
        }
    }, [queryStepIndexToScroll, scrollToStep]);

    // Скролл вверх при появлении/исчезновении отдельного шага
    const queryStandaloneStepName = useSelector((state) => state.router.location.query.stepName);
    const prevQueryStandaloneStepName = useRef(queryStandaloneStepName);

    useEffect(() => {
        if (!queryStepIndexToScroll && queryStandaloneStepName !== prevQueryStandaloneStepName.current) {
            window.scrollTo(0, 0);
        }

        prevQueryStandaloneStepName.current = queryStandaloneStepName;
    }, [queryStepIndexToScroll, queryStandaloneStepName]);

    // Автоскролл при открытии новых шагов
    const autoScrolledStepIndex = useRef(currentStepIndex);

    useEffect(() => {
        // Блокируем автоскролл если сами шаги изменились
        autoScrolledStepIndex.current = currentStepIndex;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [steps]);

    useEffect(() => {
        if (currentStepIndex === autoScrolledStepIndex.current) {
            return;
        }

        scrollToStep(currentStepIndex);
        autoScrolledStepIndex.current = currentStepIndex;
    }, [currentStepIndex, scrollToStep]);
};

export { useScroll };
